import { onBeforeUnmount, ref, toValue, type MaybeRefOrGetter } from 'vue'
import { onBeforeRouteLeave, useRouter } from 'vue-router'
import { useModal } from './use-modal'

type Options = {
  enabled?: MaybeRefOrGetter<boolean>
}

export const useUnsavedChangesGuard = (options: Options = {}) => {
  const router = useRouter()
  const modal = useModal()
  const allowed = ref(false)
  const pendingPath = ref<string | null>(null)

  const isActive = () => toValue(options.enabled ?? true) && !allowed.value

  const handleBeforeUnload = (e: BeforeUnloadEvent) => {
    if (!isActive()) return
    e.preventDefault()
    e.returnValue = ''
  }

  window.addEventListener('beforeunload', handleBeforeUnload)

  onBeforeUnmount(() => {
    window.removeEventListener('beforeunload', handleBeforeUnload)
  })

  onBeforeRouteLeave((to) => {
    if (!isActive()) return true
    pendingPath.value = to.fullPath
    modal.open()
    return false
  })

  const confirm = () => {
    allowed.value = true
    modal.close()
    if (pendingPath.value) {
      router.push(pendingPath.value)
    }
  }

  const cancel = () => {
    pendingPath.value = null
  }

  const allowLeave = () => {
    allowed.value = true
  }

  return {
    modal,
    confirm,
    cancel,
    allowLeave,
  }
}
